"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeysSchemaProperties = exports.ApiKeysSchema = void 0;
// TODO: Move all this to the shared lib whenever it's available.
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const IntegrationsStatusEnum = zod_1.z.enum(["active", "inactive", "deleted"]);
exports.ApiKeysSchema = base_schema_1.BaseSchema.extend({
    userId: zod_1.z.string(),
    value: zod_1.z.string(),
    status: IntegrationsStatusEnum,
    accountId: zod_1.z.string().optional(), // For now, until all users have an account
});
exports.ApiKeysSchemaProperties = {
    collectionName: "apiKeys",
    deleteMode: schema_properties_interface_1.DeleteMode.InStatus,
};
//# sourceMappingURL=apikeys-schema.js.map